import { render, staticRenderFns } from "./ListaFrequencia.vue?vue&type=template&id=0f39859e"
import script from "./ListaFrequencia.vue?vue&type=script&lang=js"
export * from "./ListaFrequencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports